export const BASE_URL = 'https://apiims.kryptomind.net/api/v1'
// export const BASE_URL = 'http://localhost:8000/api/v1'
